import { IComponentOptions } from "angular";
import { BulkLogResultController } from "./controller";

export const vsComponentName = "bulkLogResult";

export const bulkLogResultComponentOptions: IComponentOptions = {
  controller: BulkLogResultController,
  controllerAs: "stateController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    bulkUpdateResults: "<",
  },
};
